import { useEffect } from 'react';
import { useAuthContext } from '@picsart/growth-rc/AuthContext';
import { loadImpactScript, impactIdentify } from '../impactService/index.js';
import { U as UserSubscriptionStatesEnum } from '../userSubscriptionModel-47e03fd5.js';

var useImpactIdentify = function useImpactIdentify(userSubscriptionState) {
  var _useAuthContext = useAuthContext(),
    user = _useAuthContext.user;
  useEffect(function () {
    if (userSubscriptionState === UserSubscriptionStatesEnum.Resolved) {
      loadImpactScript().then(function () {
        impactIdentify(String((user === null || user === void 0 ? void 0 : user.id) || ''), user === null || user === void 0 ? void 0 : user.email_encoded);
      })["catch"](function () {});
    }
  }, [user === null || user === void 0 ? void 0 : user.email_encoded, user === null || user === void 0 ? void 0 : user.id, userSubscriptionState]);
};

export { useImpactIdentify as default };
//# sourceMappingURL=index.js.map
